import { Modal, Box } from '@material-ui/core';
import { AnimatedLoading } from '../portico/animated-loading/animated-loading';
import React from 'react';
import useCustomLoadingStyles from './custom-loading.styles';



interface CustomLoadingProps {
    message?: string;
    color?: 'primary' | 'secondary' | 'inherit';
}

const CustomLoading: React.FC<CustomLoadingProps> = ({ message, color }) => {
    const style = {
        position: 'absolute' as 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 0,
        pt: 2,
        px: 4,
        height: 150,
        pb: 3,
        borderRadius: '4px'
    };
    const customLoadingStyles = useCustomLoadingStyles();

    return (
        <Modal open={true} aria-labelledby="modal-title">
            <Box sx={{ ...style }} className={customLoadingStyles.customLoadingBox}>
                <h3 id="modal-title">{message}</h3>
                <AnimatedLoading />
            </Box>
        </Modal>
    )
}
export default CustomLoading;
